export default __webpack_public_path__ + "static/media/twitter.848c7029.svg";